import { useEffect, useState } from 'react';
import {
  getDocsConfig,
  getFullstoryConfig,
  isAnalyticsEnabled
} from '../../../shared/utils/config';
import { userService } from '../../../auth/services/user.service';

export function useDocsUrl({
  docLink,
  areTabsRendered,
  queryParams
}: {
  docLink: string;
  areTabsRendered: boolean;
  queryParams?: Record<string, string>;
}): [string, VoidFunction] {
  const user = userService.getUser();
  const isFullstoryTrackingEnabled = isAnalyticsEnabled(getFullstoryConfig());

  const getIframeSourceURL = () => {
    const searchParams = new URLSearchParams(queryParams);
    searchParams.set('fullstory', isFullstoryTrackingEnabled ? 'true' : 'false');

    // If body contains dark-mode then append as query params
    // to render the docs in dark mode without waiting for colorModeService
    if (document.body.classList.contains('color-mode-dark')) {
      searchParams.set('colorMode', 'dark');
    }

    if (user) {
      searchParams.set('app_user', user.email);
    }

    if (areTabsRendered) {
      searchParams.set('canShowTabs', 'true');
    }

    return `${getDocsConfig().miniDocsURL}${docLink}?${searchParams}`;
  };

  const [iframeSourceURL, setIframeSourceURL] = useState(getIframeSourceURL());

  useEffect(() => {
    setIframeSourceURL(getIframeSourceURL());
  }, [docLink, areTabsRendered, queryParams]);

  const rebuildIframeSourceURL = () => {
    setIframeSourceURL(getIframeSourceURL());
  };

  return [iframeSourceURL, rebuildIframeSourceURL];
}
